function CommonAside() {
  return (
    <aside className={`hidden`}>
      <div>CommonAside</div>
    </aside>
  );
}

export default CommonAside;